<p-toast position="bottom-center"></p-toast>

<div class="page-title" style="display: flex; align-items: center; justify-content: space-between;">
  <div>
    <h3 style="padding-top: 1rem; padding-bottom: 1rem;">
      Log Management
    </h3>
  </div>
  <div style="display: flex; gap: 1rem; align-items: center;">
    <button pButton type="button" class="export-button" (click)="exportLogs()">
      <i class="pi pi-download" style="margin-right: 0.5rem;"></i>
      Export
    </button>
  </div>
</div>

<p-card>
  <app-besharp-table
    [tableItems]="datasource"
    [totalRecords]="datasourceLength"
    [lazyMode]="true"
    [loading]="loading"
    [debounceSearchTime]="300"
    [idColumnDef]="'id'"
    [tableDefinitions]="tableDefinition"
    [actionDefinitions]="actionDefinition"
    [globalFilterFields]="globalFilterFields"
    [actionTitle]="''"
    [tableSize]="eBesharpTableSize.Small"
    [defaultActive]="'id'"
    [defaultDirection]="-1"
    [paginator]="true"
    [pageRows]="pageRows"
    [pageRowsOptions]="[5, 10, 25, 50]"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} logs'"
    (onPageChange)="onPageChange($event)"
    (onSortChange)="sortChangedEvent($event)"
    (onGlobalSearch)="onGlobalSearch($event)"
    (onColumnFilter)="onColumnFilter($event)"
  ></app-besharp-table>
</p-card>

<p-dialog 
  header="Log Details" 
  [(visible)]="showLogDetailsModal" 
  [modal]="true" 
  [style]="{ width: '50rem' }" 
  [draggable]="false" 
  [resizable]="false"
>
  <div class="log-details-modal-content" *ngIf="selectedLog">
    <div class="log-detail-section">
      <h4>Basic Information</h4>
      <div class="detail-grid">
        <div class="detail-item">
          <label>Date:</label>
          <span>{{ selectedLog.createdAt | date:'medium' }}</span>
        </div>
        <div class="detail-item">
          <label>Entity:</label>
          <span>{{ selectedLog.entity | titlecase }}</span>
        </div>
        <div class="detail-item">
          <label>Operation:</label>
          <span class="log-level" [ngClass]="'level-' + selectedLog.operationType.toLowerCase()">{{ selectedLog.operationType | uppercase }}</span>
        </div>
        <div class="detail-item">
          <label>User:</label>
          <span>{{ selectedLog.userEmail }}</span>
        </div>
      </div>
    </div>

    <div class="log-detail-section">
      <h4>Change Details</h4>
      <div class="log-message">
        {{ selectedLog.changeDetails }}
      </div>
    </div>
  </div>
  
  <ng-template pTemplate="footer">
    <p-button 
      label="Close" 
      icon="pi pi-times" 
      (onClick)="closeLogDetailsModal()"
    ></p-button>
  </ng-template>
</p-dialog>
